<template>
  <span class="client-form-label">
    <span>{{ label }}</span>
    <el-popover
      v-if="resolvedHelp"
      placement="top-start"
      width="340"
      trigger="click"
      popper-class="client-field-help-popover"
    >
      <p class="client-field-help-text">{{ resolvedHelp }}</p>
      <i
        slot="reference"
        class="el-icon-question client-field-help-icon"
        :title="$tt('点击查看说明')"
        @click.stop
      />
    </el-popover>
  </span>
</template>

<script>
export default {
  name: "ClientFormFieldHelp",
  props: {
    label: { type: String, required: true },
    helpKey: { type: String, default: "" },
  },
  computed: {
    resolvedHelp() {
      if (!this.helpKey) {
        return "";
      }
      const key = `clientFieldHelp.${this.helpKey}`;
      const text = this.$t(key);
      return text && text !== key ? text : "";
    },
  },
};
</script>

<style scoped lang="scss">
.client-form-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.client-field-help-icon {
  font-size: 14px;
  color: #909399;
  cursor: pointer;
  vertical-align: middle;
  &:hover {
    color: #409eff;
  }
}
</style>

<style lang="scss">
.client-field-help-popover {
  .client-field-help-text {
    margin: 0;
    font-size: 13px;
    line-height: 1.55;
    color: #606266;
    white-space: pre-wrap;
  }
}
</style>
